import GeneratingShippingLabel from './GeneratingShippingLabel';

export default GeneratingShippingLabel;
